import React, { Component } from 'react';
import { formatNumber } from 'utils';
import cn from 'classnames';
import styles from './Area.scss';

import Button from '../../../../common/Button/Button';
import { withTranslation } from 'react-i18next';
import i18n from '../../../../../i18n';
import { gaEvent, trackGA } from 'services/ga';
import debounce from 'lodash.debounce';

const digits = (number) => (number ? formatNumber(number) : '...');

const inputDigits = (number) => {
  const formattedNumber = formatNumber(parseInt(number, 10));
  return Number(number) === '0' || isNaN(parseInt(number, 10)) ? '' : formattedNumber;
};

export const parseSearch = (search) => {
  const { areaFrom, areaTo } = search;
  return { areaFrom, areaTo };
};

export const compileSearch = (data) => {
  const { areaFrom, areaTo } = data;
  const min = areaFrom ? Number(areaFrom) : undefined;
  const max = areaTo ? Number(areaTo) : undefined;
  return { areaFrom: min, areaTo: max };
};

export const compileRequest = compileSearch;

export const getRequest = (search) => compileRequest(parseSearch(search));

export const subtext = (search) => {
  const { areaFrom, areaTo } = parseSearch(search);
  return areaFrom || areaTo
    ? `${digits(areaFrom)} - ${digits(areaTo)}`
    : i18n.t('components.header.filtersBar.filters.area.notSelected');
};

class Area extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ...parseSearch(props.search)
    };

    this.handleMinValueChange = this.handleMinValueChange.bind(this);
    this.handleMaxValueChange = this.handleMaxValueChange.bind(this);
    this.handleClearButtonClick = this.handleClearButtonClick.bind(this);
    this.updateSearch = this.updateSearch.bind(this);

    this.debouncedEnterMinAreaEvent = debounce(this.trackInputEvent.bind(this, 'ot'), 3000);
    this.debouncedEnterMaxAreaEvent = debounce(this.trackInputEvent.bind(this, 'do'), 3000);
  }

  updateSearch() {
    const { dropdownData } = this.props;
    const compiled = compileSearch(this.state);
    dropdownData(compiled, compiled);
  }

  parseValue(value) {
    const parsed = Number(parseInt(value.replace(/\s/g, ''), 10));
    return value ? (isNaN(parsed) ? undefined : parsed) : undefined;
  }

  handleMinValueChange(event) {
    const { value } = event.target;
    const areaFrom = this.parseValue(value);
    if (this.state.areaFrom !== areaFrom) {
      this.setState({ areaFrom }, this.updateSearch);
    }
    if (value && String(value).length >= 2) {
      this.debouncedEnterMinAreaEvent();
    }
  }

  handleMaxValueChange(event) {
    const { value } = event.target;
    const areaTo = this.parseValue(value);
    if (this.state.areaTo !== areaTo) {
      this.setState({ areaTo }, this.updateSearch);
    }
    if (value && String(value).length >= 2) {
      this.debouncedEnterMaxAreaEvent();
    }
  }

  handleClearButtonClick() {
    this.setState({ areaFrom: undefined, areaTo: undefined }, this.updateSearch);
  }

  trackInputEvent(inputName) {
    const { profile, buildingData, mode, chessfilter, objectType, search: { areaFrom, areaTo } } = this.props;

    const eventName = chessfilter ? 'buildingChessFiltersInput' : 'filterInput';

    const inputValue = inputName === 'ot' ? areaFrom : areaTo;

    trackGA(gaEvent[eventName]({
      eventLabel: 'ploshchad',
      eventContent: `${inputValue} | ${inputName}`,
      eventContext: mode,
      productType: objectType,
      productName: buildingData ? buildingData.title : '',
      productID: buildingData ? buildingData.id : '',
      user_id: profile.id
    }));
  }

  render() {
    const { className, chessfilter, t, mode, profile, objectType } = this.props;
    const { areaFrom, areaTo } = this.state;

    return (
      <div className={cn(styles.Menu, className, { [styles.MenuChessfilter]: chessfilter })}>
        <p className={styles.Title}>
          {t('components.header.filtersBar.filters.area.title')}
          {
            !!(areaFrom || areaTo) &&
            <Button
              className={styles.Button}
              onClick={() => {
                this.handleClearButtonClick();
                trackGA(gaEvent.filterClearButtonsClick({
                  eventContent: 'ploshchad',
                  eventContext: mode,
                  productType: objectType,
                  user_id: profile.id
                }));
              }}
            >
              {t('components.header.filtersBar.filters.area.clear')}
            </Button>
          }
        </p>
        <div className={styles.Inputs}>
          <input
            value={inputDigits(areaFrom)}
            onChange={this.handleMinValueChange}
            className={styles.Input}
            placeholder={chessfilter ? t('components.header.filtersBar.filters.area.from') : t('components.header.filtersBar.filters.area.fromFull')}
            maxLength="7"
          />
          <span className={styles.Dash}> – </span>
          <input
            value={inputDigits(areaTo)}
            onChange={this.handleMaxValueChange}
            className={styles.Input}
            placeholder={chessfilter ? t('components.header.filtersBar.filters.area.to') : t('components.header.filtersBar.filters.area.toFull')}
            maxLength="7"
          />
        </div>
      </div>
    );
  }
}

export default withTranslation()(Area);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/Area/Area.js